module.exports = __webpack_public_path__ + "assets/panini.e5b7f584.svg";